module.exports = __webpack_public_path__ + "img/goal_other02.e5a6cd55.png";